import { Toast } from '@ks/sharp-ui';
import { canBridgeUse, useBridge } from './common';

const namespace = 'webview';

/**
 * config对象按照yoda { data }
 * @param {*} config
 * @returns {*} 调用结果
 */
export async function exitWebView(config = {}) {
    if (await canBridgeUse(namespace, 'close')) {
        const nameSpaceApi = 'webview.close';
        return await useBridge(nameSpaceApi, config);
    }
    if (await canBridgeUse(namespace, 'exitWebView')) {
        // 默认快手端内有这个方法
        const nameSpaceApi = 'webview.exitWebView';
        return await useBridge(nameSpaceApi, config);
    }
    throw new Error('Bridge Unsupported: exitWebView');
}

export async function openWebView(config = {}) {
    if (await canBridgeUse(namespace, 'open')) {
        const nameSpaceApi = 'webview.open';
        return await useBridge(nameSpaceApi, config);
    }
    if (await canBridgeUse('tool', 'loadUrlOnNewPage')) {
        const nameSpaceApi = 'tool.loadUrlOnNewPage';
        const params = {
            url: config.url,
            type: config.type || 'back',
        };
        return await useBridge(nameSpaceApi, params);
    }
    throw new Error('Bridge Unsupported: openWebView');
}

export async function getLaunchParams() {
    // 这个bridge似乎只有yoda存在
    if (await canBridgeUse(namespace, 'getLaunchParams')) {
        const nameSpaceApi = 'webview.getLaunchParams';
        return await useBridge(nameSpaceApi, {});
    }

    throw new Error('Bridge Unsupported: getLaunchParams');
}

// 复制功能
export async function setClipBoard(text) {
    if (await canBridgeUse(namespace, 'setClipBoard')) {
        const nameSpaceApi = 'webview.setClipBoard';
        const params = {
            text,
        };
        const res = await useBridge(nameSpaceApi, params);
        if (res.result !== 1) {
            Toast.info('复制失败', 1500);
        } else {
            Toast.info('已复制', 1000);
        }
    } else if (navigator.clipboard) {
        navigator.clipboard.writeText(text);
        Toast.info('已复制', 1000);
    } else {
        Toast.info('复制失败', 1500);
    }
}